import { TIPTAP_CAPTION_TYPE } from "./../../ricos-content/index.js";
const captionToPlainText = (node) => {
  const captionNode = node.content?.find(({ type }) => type === TIPTAP_CAPTION_TYPE);
  return captionNode?.content?.reduce((acc, { text }) => text !== void 0 ? acc + text : acc, "") || void 0;
};
export {
  captionToPlainText
};
//# sourceMappingURL=caption-to-plain-text.js.map
